import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "_shared/_stores/root-reducer";
import type { AppDispatch } from "_shared/_stores/store-types";
import {
  assistantTurnUnwatched,
  assistantTurnWatched,
  selectLiveTurnLabel,
} from "ai-assistant/_stores/assistant-turn-progress-redux-slice";

export interface LiveTurnStep {
  /** What the turn is doing, in the server's words, once it has said. */
  label: string | undefined;
  /** Starts listening for a turn's steps. Called before its request is sent, so none is missed. */
  watch: (turnId: string) => void;
  /** Stops listening once the turn's reply, failure or stop has arrived. */
  unwatch: (turnId: string) => void;
}

/** The live step of the turn the panel is waiting on (#7286). */
export function useLiveTurnStep(turnId: string | undefined): LiveTurnStep {
  const dispatch = useDispatch<AppDispatch>();
  const label = useSelector((state: Pick<RootState, "assistantTurnProgress">) => selectLiveTurnLabel(state, turnId));

  return {
    label,
    watch: (id: string) => dispatch(assistantTurnWatched(id)),
    unwatch: (id: string) => dispatch(assistantTurnUnwatched(id)),
  };
}
